import React from "react";
import { Linking } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { Box, MainText, PressableOpacity } from "app/components/common";

const PRIVACY_URL = "https://microdoing.com/privacy";
const PULSE_CONDITIONS =
  "https://microdoing.com/conditions-generales-dutilisation-du-site.html";

const SignupPolicy = ({}) => {
  const visitUrl = url => () => {
    Linking.openURL(url);
  };

  return (
    <Box alignItems="center">
      <PressableOpacity
        onPress={visitUrl(PRIVACY_URL)}
        style={{ justifyContent: "center" }}
      >
        <MainText variant="l3-medium" color="neutral.350">
          {i18n.t("signup-policy")}
          <MainText variant="l3-medium" color="brand.500">
            {i18n.t("privacy-policy")}
          </MainText>
        </MainText>
      </PressableOpacity>
    </Box>
  );
};

export default SignupPolicy;
